import { ChevronRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const fmtPromised = (d) => (d ? new Date(`${d}T00:00:00`).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit" }) : "");
export const deviceLabel = (it) => [it.device_type, it.brand, it.model].filter(Boolean).join(" · ") || "—";

/** Iter 164 — Modal genérico (skin nueva) con lista de reparaciones → clic abre la ficha. */
export default function RepairListModal({ title, subtitle, icon: Icon, tone, items, loading = false, onClose, onOpen, testid = "repair-list-modal" }) {
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl w-[94vw] p-0 gap-0 rounded-xl overflow-hidden" data-testid={testid}>
        <div className="px-5 py-4 border-b border-[#E6E7E1] bg-[#FBFBF8] pr-12">
          <DialogTitle className={`font-display font-bold text-lg inline-flex items-center gap-2 ${tone?.head || "text-[#0F1210]"}`}>
            {Icon && <Icon size={16} />} {title}
            <span className={`text-[10.5px] font-mono px-1.5 py-[1px] border rounded-full ${tone?.chip || "bg-[#F5F6F2] text-[#4B5158] border-[#E6E7E1]"}`} data-testid={`${testid}-total`}>{loading ? "…" : items.length}</span>
          </DialogTitle>
          <DialogDescription className="text-xs text-[#4B5158] mt-0.5">{subtitle}</DialogDescription>
        </div>
        <div className="max-h-[70vh] overflow-y-auto divide-y divide-[#E6E7E1]">
          {loading && <div className="px-5 py-8 text-center text-xs text-[#8A9098]" data-testid={`${testid}-loading`}>Cargando reparaciones…</div>}
          {!loading && items.length === 0 && <div className="px-5 py-8 text-center text-xs text-[#8A9098]">Sin reparaciones</div>}
          {items.map((it) => (
            <button key={it.id} type="button" onClick={() => onOpen(it)} data-testid={`${testid}-row-${it.code}`}
              className="w-full text-left px-5 py-3 flex items-center gap-4 hover:bg-[#EFF3E6] transition-colors">
              <span className="font-mono text-[11.5px] font-semibold bg-[#F5F6F2] border border-[#E6E7E1] text-[#4B5158] px-2 py-[2px] rounded-md shrink-0">{it.code}</span>
              <div className="min-w-0 flex-1">
                <div className="text-[13px] font-semibold text-[#0F1210] truncate">{deviceLabel(it)}</div>
                <div className="text-[12px] text-[#4B5158] truncate">{it.customer_name || "—"}</div>
              </div>
              <span className={`text-[10.5px] font-mono px-1.5 py-[1px] border rounded-md shrink-0 ${it.promised_date ? (tone?.chip || "bg-[#F5F6F2] text-[#4B5158] border-[#E6E7E1]") : "bg-white text-[#8A9098] border-[#E6E7E1]"}`}>
                {it.promised_date ? fmtPromised(it.promised_date) : "sin fecha"}
              </span>
              <ChevronRight size={14} className="text-[#8A9098] shrink-0" />
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
